import React from 'react';
import { m } from 'framer-motion';
import { ArrowRightIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { methodSteps } from '../../data/method';
export function Method() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-162" data-mp="2ao7lnam48r2j">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-163" data-mp="26nnlrza5r9cp">
        <SectionTag icon="🎯" data-id="element-164" data-mp="26nfaucxlie45">El método "Sesión en Mano"</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-bold uppercase leading-tight text-azul sm:text-4xl" data-id="element-165" data-mp="21pm1jb0zx3zn">
          El Método "Sesión en Mano"
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-166" data-mp="1rqesh01anvic">
          Preparar tu próximo entrenamiento puede ser así de sencillo:
        </p>
      </div>

      <div className="mx-auto mt-8 flex max-w-4xl flex-col gap-4 px-4 sm:flex-row sm:items-stretch sm:gap-3 sm:px-6" data-id="element-167" data-mp="1nqmiciw95hav">
        {methodSteps.map((step, i) => <React.Fragment key={step.n} data-id="element-168" data-mp="3i3vsmcwmh6u6" data-mpi={i}>
            <m.div initial={{
          opacity: 0,
          y: 14
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.08
        }} className="flex flex-1 flex-col items-center rounded-2xl border border-gris-claro bg-white p-6 text-center shadow-card" data-id="element-169" data-mp="3i0q1yt8chwwc">
              <div className="flex h-12 w-12 items-center justify-center rounded-full bg-azul-light" data-id="element-170" data-mp="32klsfpcu3wnb">
                <step.icon size={22} className="text-azul" data-id="element-171" data-mp="3qag1rwxy332t" />
              </div>
              <p className="mt-3 font-heading text-lg font-bold uppercase tracking-wide text-azul-dark" data-id="element-172" data-mp="3v8hiwcbt8sbn">
                {step.n}. {step.title}
              </p>
              <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-173" data-mp="3hf09vlgr2xzv">{step.text}</p>
            </m.div>
            {i < methodSteps.length - 1 && <ArrowRightIcon size={20} className="mx-auto hidden flex-shrink-0 self-center text-naranja sm:block" aria-hidden="true" data-id="element-174" data-mp="d1jxjqlipcdh" />}
          </React.Fragment>)}
      </div>

      <p className="mx-auto mt-8 max-w-2xl px-4 text-center text-sm leading-relaxed text-muted sm:px-6 sm:text-base" data-id="element-175" data-mp="nnqcmjg7hlrp">
        Sin pasarte horas buscando en YouTube. Sin juntar ejercicios aleatorios que no tienen hilo
        conductor. Sin llegar a la pista preguntándote qué vas a hacer cuando los jugadores ya están en
        círculo mirándote.
      </p>
    </section>;
}